import api from "../api"
import { saveAs } from 'file-saver'

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_DASHBOARD_ORDER: 'FETCH_DASHBOARD_ORDER',
    FETCH_ORDER_LIST_PAGE: 'FETCH_ORDER_LIST_PAGE',
    FETCH_ORDER_DETAILS: 'FETCH_ORDER_DETAILS',
    FETCH_ORDER_RECEIPTS_BY_ORDER: 'FETCH_ORDER_RECEIPTS_BY_ORDER',
    FETCH_RECEIPT_SERVICES_FREE_BY_ORDER: 'FETCH_RECEIPT_SERVICES_FREE_BY_ORDER',
    FETCH_SAVE_RECEIPT_BY_ORDER: 'FETCH_SAVE_RECEIPT_BY_ORDER',
    FETCH_ORDER_DETAIL_RECEIPT: 'FETCH_ORDER_DETAIL_RECEIPT',
    FETCH_GET_ORDER_INVOICE: 'FETCH_GET_ORDER_INVOICE',
    FETCH_DELETE_ORDER_RECEIPTS: 'FETCH_DELETE_ORDER_RECEIPTS',
    FETCH_DELETE_ORDER_INVOICE: 'FETCH_DELETE_ORDER_INVOICE',
    RESULT_UPLOAD_ORDER_INVOICE: 'RESULT_UPLOAD_ORDER_INVOICE',
    DOWNLOAD_ORDERS_EXCEL: 'DOWNLOAD_ORDERS_EXCEL'
}

export const fetch_Dashboard = (lang, token, supplierId, onError, onSuccess) => dispatch => {
    api.Order().fetchDashboard(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DASHBOARD_ORDER,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_order_list_Page = (lang, token, values, onError, onSuccess, source) => dispatch => {
    api.Order().fetchListPage(lang, token, values)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_LIST_PAGE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err, source))
}


export const fetch_other_transactions_order_detail = (lang, token, id, onError, onSuccess) => dispatch => {
    api.Order().fetchOrderDetail(lang, token, id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAILS,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Order_receipts_by_order = (lang, token, id, onError, onSuccess) => dispatch => {
    api.Order().fetchOrderReceiptsByOrder(lang, token, id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_RECEIPTS_BY_ORDER,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_receipt_services_free_by_order = (lang, token, id, onError, onSuccess) => dispatch => {
    api.Order().fetchReceiptServicesFreeByOrder(lang, token, id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_RECEIPT_SERVICES_FREE_BY_ORDER,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const save_receipt = (lang, token, body, onError, onSuccess) => dispatch => {
    api.Order().saveReceipt(lang, token, body)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_SAVE_RECEIPT_BY_ORDER,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const UpdateOrderInvoice = (lang, token, orderId, files, onError, onSuccess) => dispatch => {
    api.Order().UpdateOrderInvoice(lang, token, orderId, files)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_ORDER_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const GetInvoiceByOrder = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Order().GetInvoiceByOrder(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_GET_ORDER_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const download_document_by_id = (lang, token, values, onError, onSuccess) => dispatch => {
    api.Order().DownloadDocumentById(lang, token, values)
        .then(response => {
            response.data.forEach((document) => {
                const data = "data:" + document.docFileTypVal + ";base64," + document.fileBase64
                saveAs(data, document.fileName)
            });
            onSuccess();
        })
        .catch((err) => {
            onError(err)
        })
}
export const DeleteDocumentsInvoiceByOrder = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Order().DeleteDocumentsInvoiceByOrder(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DELETE_ORDER_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}
export const DeleteOrderReceiptsByOrder = (lang, token, pymtOrdReceiptId, pymtOrdId, onError, onSuccess) => dispatch => {
    api.Order().DeleteOrderReceiptsByOrder(lang, token, pymtOrdReceiptId, pymtOrdId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DELETE_ORDER_RECEIPTS,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}


export const update_status_order_review_payment = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Order().UpdateStatusOrderReviewPayment(lang, token, orderId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}
export const DownloadExcel = (lang, token, values, onError, onSuccess, source) => dispatch => {
    api.Order().DownloadExcelOrders(lang, token, values)
        .then(response => {
            response.data.forEach((document) => {
                const data = "data:" + document.docFileTypVal + ";base64," + document.fileBase64
                saveAs(data, document.fileName)
            });
            onSuccess();
        })
        .catch(err => onError(err, source))
}